<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 11a1 1 0 0 1 .117 1.993L18 13H6a1 1 0 0 1-.117-1.993L6 11h12Z"/></svg></template>